module.exports = __webpack_public_path__ + "img/744.dde3766f.jpg";